import type { SanitizeFileName } from "./types";

const DISALLOWED_CHARS = /[^\p{L}\p{N}._-]+/gu;
const TRIM_OUTSIDE_PUNCTUATION = /^[._-]+|[._-]+$/g;

export const sanitizeFileName: SanitizeFileName = ({
  rawName,
  fallback = "untitled",
}) => {
  const cleaned = rawName
    .replace(DISALLOWED_CHARS, "_")
    .replace(TRIM_OUTSIDE_PUNCTUATION, "");
  return cleaned || fallback;
};
